/*
 * Cozy cart cross-sell ADD button.
 *
 * Defines the <cozy-cart-add> custom element. This MUST load from a normal (non-morphed) page
 * asset rather than an inline <script> inside the cross-sell snippet: the cross-sell card is
 * injected into the open cart drawer via section morphing, and <script> tags inside morphed
 * HTML never execute. Loading it globally means the element is defined on every page, so any
 * <cozy-cart-add> in the DOM — including cards morphed into the drawer on the first add — is
 * upgraded automatically and its ADD button works.
 *
 * On click: POST /cart/add for the suggested variant, requesting the cart-items-component
 * section(s), then dispatch the theme's own cart:update event with the returned section HTML so
 * the open drawer re-renders (new line appears, cross-sell hides once both flavors are present).
 */
(function () {
  if (!('customElements' in window)) return;
  if (customElements.get('cozy-cart-add')) return;

  customElements.define(
    'cozy-cart-add',
    class extends HTMLElement {
      connectedCallback() {
        if (this.__cozyInit) return;
        this.__cozyInit = true;
        var btn = this.querySelector('button');
        if (!btn) return;
        this.__btn = btn;
        this.__live = this.querySelector('[data-cozy-live]');
        btn.addEventListener('click', this.__onClick.bind(this));
      }

      __sectionIds() {
        var ids = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          var id = el.getAttribute('data-section-id');
          if (id && ids.indexOf(id) === -1) ids.push(id);
        });
        return ids;
      }

      __onClick() {
        var self = this;
        var btn = this.__btn;
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;
        btn.disabled = true;

        var addUrl =
          window.Theme && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add';

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            sections: self.__sectionIds().join(','),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data && data.status) {
              // Add failed (e.g. sold out) - re-enable and stop.
              btn.disabled = false;
              return;
            }
            if (self.__live) self.__live.textContent = 'Added';
            var sections = data && data.sections ? data.sections : null;
            return fetch('/cart.js')
              .then(function (r) {
                return r.json();
              })
              .catch(function () {
                return null;
              })
              .then(function (cart) {
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: cart,
                      sourceId: 'cozy-cart-xsell',
                      data: {
                        source: 'cozy-cart-xsell',
                        sections: sections,
                        itemCount: cart ? cart.item_count : undefined,
                      },
                    },
                  })
                );
              });
          })
          .catch(function () {
            btn.disabled = false;
          });
      }
    }
  );
})();
